<template>
  <div class="creation-demand-step-planning">
    <h2 class="step-title">
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@PLANNING_TITLE")) }}
    </h2>
    <div class="creation-week-planning-selection">
      <ul>
        <li v-for="weekday in weekdays" :key="weekday.id">
          <section>
            <b>{{ weekday.label }}</b>
            <IosToggle :model-value="isSelected(weekday.id)" @update:model-value="toggleDay(weekday)" />
          </section>
          <Schedule
            v-if="isSelected(weekday.id)"
            :start-time="getPlanningDay(weekday.id)[ICreationStepPlanningDay.start]"
            :end-time="getPlanningDay(weekday.id)[ICreationStepPlanningDay.end]"
            :break-time-duration="getPlanningDay(weekday.id)[ICreationStepPlanningDay.break]"
            :schedule-options="scheduleOptions"
            @select-start="setSchedule({ dayId: weekday.id, property: ICreationStepPlanningDay.start, value: $event })"
            @select-end="setSchedule({ dayId: weekday.id, property: ICreationStepPlanningDay.end, value: $event })"
            @select-break-duration="setSchedule({ dayId: weekday.id, property: ICreationStepPlanningDay.break, value: $event })"
          />
          <IconBoxWrapper v-if="!isSelected(weekday.id)" icon="icon-f-clock" icon-color="white" class="creation-week-planning-disabled">
            <section>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@PLANNING_DISABLED") }}</section>
          </IconBoxWrapper>
        </li>
      </ul>
    </div>
    <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
      <section class="q-footer q-layout__section--marginal fixed-bottom">
        <div class="text-center">
          <QChip v-if="hoursCount" size="18px" color="primary" text-color="white">
            {{ $tc("CORE.COMPONENTS.OFFERS.@NB_DAYS", planning.selectedDaysCount()) }} / {{ hoursCount }}
          </QChip>
          <QBtn
            color="secondary"
            class="full-width btn-navigation"
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@PLANNING_CONFIRM')"
            no-caps
            :disabled="!planning.isValid()"
            :loading="loading"
            @click.once="save"
          />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
  import { ICreationStepPlanning, ICreationStepPlanningDay } from "@core/models";
  import { ScrollManager } from "@core/managers/scroll.manager";
  import { DatesHelpers, ScheduleHelpers } from "@core/helpers";
  import cloneDeep from "lodash.clonedeep";

  import Schedule from "@core/components/forms/Schedule.component.vue";

  export default {
    components: {
      Schedule,
    },
    props: {
      transition: {
        type: Boolean,
        required: false,
      },
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        planning: undefined,
      };
    },
    computed: {
      weekdays() {
        return DatesHelpers.weekdays;
      },
      hoursCount() {
        return this.planning.getPlanningTotalHours() > 0 ? DatesHelpers.formatMinsToHrsMins(this.planning.getPlanningTotalHours()) : null;
      },
    },
    created() {
      ScrollManager.scrollToTop();
      // we clone in order to avoid the planning days being copied by reference
      this.planning = cloneDeep(this.stepData);
      if (!this.planning.isSpecified()) {
        this.initPlanning();
      } else {
        this.planning.setPlanningDays();
      }
      this.ICreationStepPlanningDay = ICreationStepPlanningDay;
      this.setScheduleOptions();
    },
    methods: {
      initPlanning() {
        // if planning is empty when we init, auto select all days
        if (this.planning.noDaySelected()) {
          this.planning.initFromWeek();
        }
      },
      toggleDay(day) {
        this.planning.toggleDay(day.id);
      },
      setSchedule({ dayId, property, value }) {
        // if this is the first time the user set a schedule
        if (this.planning.days.every((d) => d[property] === undefined)) {
          // we set for every activated days
          this.planning.days
            .filter((d) => d.selected)
            .forEach((d) => {
              this.planning.scheduleDay({ dayId: d.id, property, value });
            });
        } else {
          // else, we only set the relevant day
          this.planning.scheduleDay({ dayId, property, value });
        }
      },
      setScheduleOptions() {
        this.scheduleOptions = ScheduleHelpers.getFullScheduleOptions({
          stampText: this.$t("CORE.COMPONENTS.SCHEDULE.@DAY_PLUS_ONE"),
          nullBreakLabel: this.$t("CORE.COMPONENTS.SCHEDULE.@BREAK_NONE"),
        });
      },
      isSelected(id) {
        return this.planning.isDaySelected(id);
      },
      getPlanningDay(dayId) {
        return this.planning.getDays().find((d) => d.id === dayId);
      },
      save() {
        // this.planning.setSpecified();
        this.$emit("saveStep", {
          [ICreationStepPlanning.days]: this.planning[ICreationStepPlanning.days],
        });
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-planning {
    .extra-tipbox {
      margin-top: 40px;
      margin-bottom: 40px;
    }
    .creation-week-planning-selection {
      ul {
        padding: 0;
        list-style: none;

        li {
          padding: 5px 0;

          > section {
            padding: 10px 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            b {
              color: $primary-medium;
              text-transform: capitalize;
            }
          }
        }
      }

      .creation-week-planning-disabled {
        section {
          display: flex;
          align-items: center;
          padding: 5px 15px;
          color: #979797;
        }
      }
    }
  }
</style>
